import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import messages from '../global/messages';

export class HttpHandlingInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
			// this handle success message
			map((response) => {
				if (response.type === HttpEventType.Response) {
					let data = response.body;
					if (!data) return response;
					// if API response is String then try to parse it into JSON
					if ((typeof data) === 'string') {
						try {
							data = JSON.parse(data);
						} catch {
							// if parse fail which is case when the response is not json string then try get matching message
							const message = messages[data];
							if (message) {
								return response.clone({
									body: message.msg
								});
							} if (!data.includes('WARNING','INFO','CRITICAL')) {
								return response.clone({
									body: data
								});
							} else {
								// return default error
								return response.clone({
									body: messages['PROFILEREGO-WARNING-1261'].msg
								});
							}
						}
					}
					// this case if response include code e.g apply for pin and invite sub user
					if ('code' in data) {
						const baseMessage = messages[data.code];
						if (baseMessage?.msg) {
							try {
								// replace {} with information we have e.g mobileNumber, device name
								const keys = baseMessage.msg.match(new RegExp('{(.*?)}', 'g'));
								const key = keys[0].replace(/[{}]/g, '');
								const message = baseMessage.msg.replace(new RegExp('{(.*?)}', 'g'), data.data[key]);
								data = message;
							} catch (err) {
								data = baseMessage.msg;
							}
							return response.clone({
								body: data
							});
						}
					}
				}
				// return raw response e.g upcoming json data
				return response;
			}),
			// handle error message 404, 400, 500 etc
      catchError((error: HttpErrorResponse) => {
				const defaultErrCode = 'PROFILEREGO-WARNING-1261';
				const response = {
					message: 'API URL not found',
					raw: '',
					error: 0,
					code: defaultErrCode
				};
				if (String(error.name) === 'TimeoutError') {
					response.message = 'Timeout has accourred';
					response.raw = error.message;
					response.error = error.status;
				} else if (error.error instanceof ErrorEvent) {
						// tslint:disable-next-line:max-line-length
						response.message = error.error.message || messages[defaultErrCode].msg;
						response.error = error.status;
						response.raw = error.error.message;
				} else {
					response.message = error instanceof HttpErrorResponse ? messages[defaultErrCode].msg : error;
					response.raw = error.message;
					response.error = error.status;
					if ('error' in error) {
						if (error.error?.text) {
							response.message = messages[error.error.text].msg;
							response.code = error.error.text;
						} else if (error.error?.code) {
							response.message = messages[error.error.code].msg;
							response.code = error.error.code;
						} else {
							response.message = error.error?.message || (messages[error?.error] || messages[defaultErrCode])?.msg;
							response.code = error.error;
						}
					}
				}
        // Handle the error or rethrow it
        return throwError(() => response);
      })
    );
  }
}